import { Box, Tab, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react';
import { nanoid } from 'nanoid';
import React from 'react';
/* Built In Imports */

/* External Imports */

/* Internal Imports */
/* Components */
import TabPanelCard from '@shi/components/card/TabPanelCard';

/* Services */

const TabGroupV2 = ({ sectionContent, region, lang }) => {
  return (
    <Box>
      <Tabs isFitted>
        <TabList
          h={{ base: '69px' }}
          background="#FAE2AB"
          borderRadius="3px 3px 0 0"
          position="sticky"
          top="0"
          zIndex={5}
        >
          {sectionContent.tabContent.map(tab => {
            return (
              <Tab
                key={nanoid()}
                _selected={{
                  color: '#CE8200',
                  borderBottom: '4px solid #CE8200',
                }}
                bg="#FAE2AB"
                textTransform="upperCase"
                fontFamily="FedraSansStd-medium"
                _active={{ bg: '#FAE2AB' }}
              >
                {tab.title}
              </Tab>
            );
          })}
        </TabList>

        <TabPanels bg="#FFF7E5">
          {sectionContent.tabContent.map(tab => {
            return (
              <TabPanel key={nanoid()}>
                <Box>
                  {tab.content[0].cards.map((card, index) => {
                    return (
                      <TabPanelCard
                        region={region}
                        key={nanoid()}
                        borderBottom={index != tab.content[0].cards.length - 1}
                        lang={lang}
                        tabContent={card}
                      />
                    );
                  })}
                </Box>
              </TabPanel>
            );
          })}
        </TabPanels>
      </Tabs>
    </Box>
  );
};

export default TabGroupV2;
